
export const API_URL = 'https://fitnessnewapp.ru/api';

export const BITRIX_URL = 'https://pr.prilf.ru/fitness/hs/mobileapp';
export const BITRIX_USERNAME = 'Webservice';
export const BITRIX_PASSWORD = 'rheujvdhfub';

// Ключи ЮKassa удалены вместе с ней: секретный ключ лежал прямо во фронтенде
// и уезжал в публичный бандл. Платежи идут через Т-Кассу, а её пароль терминала
// живёт только в env бэкенда и в браузер не попадает.

export const YANDEX_API_KEY = '676d4f73-6539-413f-be14-c5b4cd05eaa0';

